module.exports = __webpack_public_path__ + "img/UntenNebenFuesseSeiteTransp.da164296.png";